export enum EZadostStatus {
    KDOPLNENI = 'kdoplneni',
    ROZPRACOVANO = 'rozpracovano',
    KODESLANI = 'kodeslani',
    AKCEPTOVANO = 'akceptovano',
    ZAMITNUTO = 'zamitnuto',
    ODESLANO = 'odeslano',
    ZRUSENO = 'zruseno'
}
